import slugify from "slugify";

export default {
    methods: {
        generateEventUrl(event) {
            let slug = slugify(event.title, {
                lower: true,
                remove: /[*„+~.,/()'"!:@]/g
            });

            return `https://www.localticketing.de/events/${event.id}-${slug}`;
        }
    }
}